import React from 'react'
import loadableVisibility from 'react-loadable-visibility/loadable-components'
import Shimmer from './Shimmer'

const LoadingShimmer = ({ width, height }) => <Shimmer width={width} height={height} />

export const ProductView = loadableVisibility(() => import('./ProductView'), {
  render: ({ Component, loading, ownProps }) => {
    if (loading) {
      return <LoadingShimmer width={'100%'} height="120px" />
    }
    return <Component {...ownProps} />
  }
})
/* export const StyledImage = loadableVisibility(() => import('./StyledImage'), {
  render: ({ Component, loading, ownProps }) => {
    if (loading) {
      return <LoadingShimmer width={'100%'} height="80px" />
    }
    return <Component {...ownProps} />
  }
}) */

export * from './StyledComponents'
export { default as Button } from './Button'
export { default as Icon } from './Icon'
export { default as Header } from './Header'
export { default as TextField } from './TextField'
export { default as Card } from './Card'
export { default as ProgressBar } from './ProgressBar'
export { default as SelectBox } from './SelectBox'
export { default as StyledSlider } from './StyledSlider'
export { default as Slick } from './Slick'
export { default as Footer } from './Footer'
export { default as Favorite } from './Favorite'
export { default as TopSection } from './TopSection'
export { default as Input } from './Input'
export { default as StyledImage } from './StyledImage'
export { default as Sale } from './Sale'
export { default as Modal } from './Modal'
export { default as Tooltip } from './Tooltip'
export { default as Counter } from './Counter'
export { default as Toast } from './Toast'
export { default as ListView } from './ListView'
export { default as Checkbox } from './Checkbox'
export { default as ImageCapture } from './ImageCapture'
export { default as Shimmer } from './Shimmer'
export { default as PageLoader } from './PageLoader'
export { default as PieChart } from './PieChart'
export { default as ActionCard } from './ActionCard'
export { default as TextArea } from './TextArea'
export { default as TeamCard } from './TeamCard'
export { default as UserContent } from './UserContent'
export { default as PageWrapper } from './PageWrapper'
export { default as CustomSlider } from './CustomSlider'
export { default as Category } from './Category'
export { default as SearchSuggestion } from './SearchSuggestion'
export { default as GraphBar } from './GraphBar'
export { default as ModalLightbox } from './ModalLightbox'
export { default as ImageModal } from './ImageModal'
export { default as Hidden } from './Hidden'
export { default as WarningCard } from './WarningCard'
export { default as IconMenu } from './IconMenu'
export { default as SecondaryHeader } from './SecondaryHeader'



// WEBPACK FOOTER //
// ./src/components/index.js